import { Breadcrumb } from "client/Components";
import { ReactElement } from "react";
import { SelectedFolder } from "./useFolderChildren";

export type EmailBreadcrumbProps = {
	items: readonly SelectedFolder[];
	onOpenFolder: (item: SelectedFolder) => void;
};

export const EmailBreadcrumb = (props: EmailBreadcrumbProps): ReactElement => {
	const {
		items,
		onOpenFolder
	} = props;

	return (
		<Breadcrumb
			segments={items}
			onNavigate={onOpenFolder}
			trackingId="bread-crumb"
			getSegmentTrackingId={getSegmentTrackingId}
		/>
	);
};
EmailBreadcrumb.displayName = "EmailBreadcrumb";

function getSegmentTrackingId(item: SelectedFolder): string {
	return item.id ?? "";
}
